import {inject, Injectable, PLATFORM_ID} from '@angular/core';
import {SessionStorageService} from '@dcp/configurator';
import {
  EDDL_STORAGE_HELPER_NAME,
  EddlSessionHelperContent,
} from '@app/services/analytics/EDDL/models/eddl-adobe-tracking-data';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class DcpEddlSessionHelperService {

  private platformId = inject(PLATFORM_ID);
  private sessionStorageService = inject(SessionStorageService);

  public updateSession(data: EddlSessionHelperContent) {
    if (isPlatformBrowser(this.platformId)) {
      const existingSessionData = this.sessionStorageService.getItem(EDDL_STORAGE_HELPER_NAME);
      if (!existingSessionData) {
        this.createSessionHelper(data)
      } else {
        let updatedContent: EddlSessionHelperContent[] = JSON.parse(existingSessionData);
        if (updatedContent.some(content => content.uniqueToken === data.uniqueToken)) {
          updatedContent.map((content) => {
            if (content.uniqueToken === data.uniqueToken) {
              return {
                ...content,
                extras: [
                  ...content.extras.filter(extra =>
                    !data.extras.some(dE => dE.event === extra.event)
                  ),
                  ...data.extras
                ]
              }
            } else {
              return {...content, ...data}
            }
          })
        } else {
          updatedContent = [...updatedContent, data]
        }

        this.sessionStorageService.setItem(
          EDDL_STORAGE_HELPER_NAME,
          JSON.stringify(updatedContent)
        )
      }
    }
  }

  public createSessionHelper(data: EddlSessionHelperContent) {
    if (isPlatformBrowser(this.platformId)) {
      this.sessionStorageService.setItem(EDDL_STORAGE_HELPER_NAME, JSON.stringify([data]))
    }
  }

  public clearSessionHelper(uniqueId: string, event?: string) {
    if (isPlatformBrowser(this.platformId)) {
      const existingSessionData = this.sessionStorageService.getItem(EDDL_STORAGE_HELPER_NAME);

      if (existingSessionData === null) {
        return;
      }

      const existingSessionParsedData: EddlSessionHelperContent[] = JSON.parse(existingSessionData ?? '{}');
      const existingUnique: EddlSessionHelperContent = existingSessionParsedData.find(session => session.uniqueToken === uniqueId);

      let updatedSession: EddlSessionHelperContent[] = [
        ...existingSessionParsedData.filter(session => session.uniqueToken !== uniqueId),
        (event
          ? {uniqueToken: uniqueId, extras: existingUnique.extras.filter(extra => extra.event !== event)}
          : null)

      ]

      if (updatedSession.length > 1 && updatedSession.some(u => u.extras.length === 0)) {
        updatedSession = [
          ...updatedSession.filter(session => session.extras.length > 0)
        ]
      }

      if (updatedSession.length === 1 && !updatedSession[0]?.extras) {
        return this.sessionStorageService.removeItem(EDDL_STORAGE_HELPER_NAME)
      }

      return this.sessionStorageService.setItem(EDDL_STORAGE_HELPER_NAME, JSON.stringify(updatedSession));
    }
  }
}
